function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_3348",
  "data-name": "Group 3348",
  transform: "translate(-1012.171 -266.829)"
}, /*#__PURE__*/React.createElement("line", {
  id: "Line_1264",
  "data-name": "Line 1264",
  x1: 6.125,
  transform: "translate(1026.798 295.422)",
  fill: "none",
  stroke: "#344154",
  strokeMiterlimit: 10,
  strokeWidth: 1.6
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_1266",
  "data-name": "Line 1266",
  x1: 6.125,
  transform: "translate(1026.798 293.037)",
  fill: "none",
  stroke: "#344154",
  strokeMiterlimit: 10,
  strokeWidth: 1.6
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_446",
  "data-name": "Rectangle 446",
  width: 2.145,
  height: 12.917,
  transform: "translate(1040.721 292.723) rotate(180)",
  fill: "none",
  stroke: "#344154",
  strokeMiterlimit: 10,
  strokeWidth: 1.6
}), /*#__PURE__*/React.createElement("path", {
  id: "Rectangle_447",
  "data-name": "Rectangle 447",
  d: "M1.072,0h0A1.072,1.072,0,0,1,2.145,1.072V3.718a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V1.072A1.072,1.072,0,0,1,1.072,0Z",
  transform: "translate(1040.721 296.441) rotate(180)",
  fill: "none",
  stroke: "#344154",
  strokeMiterlimit: 10,
  strokeWidth: 1.6
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_1265",
  "data-name": "Line 1265",
  y2: 2.162,
  transform: "translate(1039.649 296.441)",
  fill: "none",
  stroke: "#344154",
  strokeMiterlimit: 10,
  strokeWidth: 1.6
}), /*#__PURE__*/React.createElement("path", {
  id: "Rectangle_448",
  "data-name": "Rectangle 448",
  d: "M0,0H2.145a0,0,0,0,1,0,0V1.072A1.072,1.072,0,0,1,1.072,2.145h0A1.072,1.072,0,0,1,0,1.072V0A0,0,0,0,1,0,0Z",
  transform: "translate(1040.721 279.806) rotate(180)",
  fill: "none",
  stroke: "#344154",
  strokeMiterlimit: 10,
  strokeWidth: 1.6
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_3347",
  "data-name": "Group 3347",
  transform: "translate(1015.51 270.24)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_3346",
  "data-name": "Group 3346",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_4284",
  "data-name": "Path 4284",
  d: "M1040.861,291.926a19.046,19.046,0,0,1-.465-4.272c0-5.148,1.877-9.322,4.193-9.322s4.193,4.174,4.193,9.322-1.877,9.323-4.193,9.323a2.008,2.008,0,0,1-.775-.159",
  transform: "translate(-1036.246 -278.331)",
  fill: "none",
  stroke: "#344154",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.6
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_4285",
  "data-name": "Path 4285",
  d: "M1075.341,292.948a5.621,5.621,0,0,0-4.2-.443",
  transform: "translate(-1059.494 -288.911)",
  fill: "none",
  stroke: "#344154",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.6
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_4286",
  "data-name": "Path 4286",
  d: "M1026.181,322.442a2.973,2.973,0,0,1-2.529-1.233c-.672-1.164-.052-2.9,1.458-4.661",
  transform: "translate(-1023.382 -307.226)",
  fill: "none",
  stroke: "#344154",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.6
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_3343",
  "data-name": "Group 3343",
  transform: "translate(14.899 5.745)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_283",
  "data-name": "Ellipse 283",
  cx: 1.356,
  cy: 1.356,
  r: 1.356,
  strokeWidth: 1.6,
  stroke: "#344154",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_3344",
  "data-name": "Group 3344",
  transform: "translate(1.025 2.136)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_4287",
  "data-name": "Path 4287",
  d: "M1030.3,288.444a1.356,1.356,0,1,0-1.356,1.356A1.356,1.356,0,0,0,1030.3,288.444Z",
  transform: "translate(-1027.585 -287.088)",
  fill: "none",
  stroke: "#344154",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.6
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_3345",
  "data-name": "Group 3345",
  transform: "translate(4.15 14.965)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_4288",
  "data-name": "Path 4288",
  d: "M1043.108,341.035a1.356,1.356,0,1,0-1.356,1.356A1.356,1.356,0,0,0,1043.108,341.035Z",
  transform: "translate(-1040.396 -339.679)",
  fill: "none",
  stroke: "#344154",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.6
})), /*#__PURE__*/React.createElement("path", {
  id: "Path_4289",
  "data-name": "Path 4289",
  d: "M1027.666,307.1c-2.745-2.042-4.418-4.435-4.276-6.147",
  transform: "translate(-1023.382 -295.438)",
  fill: "none",
  stroke: "#344154",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1.6
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_4290",
  "data-name": "Path 4290",
  d: "M1062.719,306.941c3.243,2.412,4.99,5.315,4.014,7-.672,1.164-2.488,1.5-4.766,1.068a15.507,15.507,0,0,1-2.961-.9",
  transform: "translate(-1050.317 -299.962)",
  fill: "none",
  stroke: "#344154",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1.6
})), /*#__PURE__*/React.createElement("path", {
  id: "Path_4291",
  "data-name": "Path 4291",
  d: "M1044.03,293.046a13.16,13.16,0,0,1,3.483,1.219",
  transform: "translate(-1038.993 -289.456)",
  fill: "none",
  stroke: "#344154",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.6
})), /*#__PURE__*/React.createElement("path", {
  id: "Path_4292",
  "data-name": "Path 4292",
  d: "M1016.008,295.213v.9a2.135,2.135,0,0,0,2.135,2.135h17.11V267.629h-22.283v25.449a2.135,2.135,0,0,0,2.135,2.135Z",
  fill: "none",
  stroke: "#344154",
  strokeMiterlimit: 10,
  strokeWidth: 1.6
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_4293",
  "data-name": "Path 4293",
  d: "M1104.318,275.07h2.051v6.692",
  transform: "translate(-69.065 -5.626)",
  fill: "none",
  stroke: "#344154",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1.6
}));

var SvgResearchIcon = function SvgResearchIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29.35,
    height: 32.221,
    viewBox: "0 0 29.35 32.221",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgResearchIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/research-icon.34047c3d.svg";
export { ForwardRef as ReactComponent };